import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMerchants = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19.9812 5.63004L18.85 0.973268C18.7113 0.401135 18.2112 0 17.6375 0H2.36375C1.79 0 1.29 0.401135 1.15 0.973268L0.01875 5.63004C0.00625 5.68018 0 5.73289 0 5.78561C0 7.55729 1.33125 8.99983 2.96875 8.99983C3.92 8.99983 4.76875 8.51256 5.3125 7.75657C5.85625 8.51256 6.705 8.99983 7.65625 8.99983C8.6075 8.99983 9.45625 8.51256 10 7.75657C10.5437 8.51256 11.3912 8.99983 12.3438 8.99983C13.2963 8.99983 14.1438 8.51256 14.6875 7.75657C15.2312 8.51256 16.0788 8.99983 17.0312 8.99983C18.6688 8.99983 20 7.55729 20 5.78561C20 5.73289 19.9937 5.68018 19.9812 5.63004Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.0312 10.2859C16.18 10.2859 15.3713 10.0184 14.6875 9.52987C13.32 10.5083 11.3675 10.5083 10 9.52987C8.6325 10.5083 6.68 10.5083 5.3125 9.52987C4.62875 10.0184 3.82 10.2859 2.96875 10.2859C2.355 10.2859 1.77625 10.138 1.25 9.88601V16.7143C1.25 17.424 1.81 18 2.5 18H7.5V12.8572H12.5V18H17.5C18.19 18 18.75 17.424 18.75 16.7143V9.88601C18.2237 10.138 17.645 10.2859 17.0312 10.2859Z",
		fill: "currentColor"
	})]
});
export default SvgMerchants;
